export default __webpack_public_path__ + "static/media/icon-action-delete.73e45283.svg";